const config = {
  development: {
    apiUrl: 'http://localhost:3000',
    debug: true,
    imageBaseUrl: 'http://localhost:3000/images',
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL,
    debug: false,
    imageBaseUrl: process.env.REACT_APP_IMAGE_BASE_URL,
  },
  test: {
    apiUrl: 'http://localhost:3000',
    debug: true,
    imageBaseUrl: 'http://localhost:3000/images',
  },
};

const environment = process.env.NODE_ENV || 'development';

export default {
  ...config[environment],
  env: environment,
  appName: 'Aruba Creative Studio',
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'ar'],
  defaultTheme: 'light',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  contactEmail: 'info@arubastudio.com',
  socialMedia: {
    facebook: 'https://www.facebook.com/aruba.creative.09',
    instagram: 'https://www.instagram.com/arubastudio',
    linkedin: 'https://www.linkedin.com/company/arubastudio',
    whatsapp: 'https://wa.me/message/UXA23MPLONOAP1',
  },
};
